import { randomId } from "../helpers/general";

export default {
  install: Vue => {
    Vue.mixin({
      methods: {
        createDropdownButton({
          items,
          menuWidth,
          buttonId = false,
          noPadding = false
        }) {
          if (!items.length) {
            return "";
          }

          bindItemsArr.call(this);

          const button = {
            id: buttonId ? buttonId : randomId(12),
            items: items.map(item => ({
              ...item,
              id: randomId(12)
            })),
            menuWidth: menuWidth
          };

          this._dropdownButtons.push(button);

          return `
          <i 
            id="${button.id}" 
            tabindex="0"
            class="fa fa-ellipsis-v color-custom-dark-grey hover-text-primary b-action-item grid-action-icon ${
              noPadding ? "pt-0 pb-0" : ""
            } ">
          </i>
          `;
        },
        hookDropdownButtons() {
          bindItemsArr.call(this);

          setTimeout(() => {
            let i = this._dropdownButtons.length;
            while (i--) {
              const button = this._dropdownButtons[i];
              const el = document.getElementById(button.id);
              if (el) {
                if (!button.handler) {
                  button.handler = handleClick.bind(this, button);
                  el.addEventListener("click", button.handler);
                }
              } else {
                this._dropdownButtons.splice(i, 1);
              }
            }
          });
        },
        hookDropdownButtonsInSupervisonNodes() {
          bindItemsArr.call(this);

          setTimeout(() => {
            let i = this._dropdownButtons.length;
            while (i--) {
              const button = this._dropdownButtons[i];
              const el = document.getElementById(button.id);
              if (el) {
                if (!button.handler) {
                  button.handler = handleClick.bind(this, button);
                  el.addEventListener("click", button.handler);
                }
              }
            }
          });
        },
        clearHandlers(buttonIds) {
          let i = this._dropdownButtons.length;
          while (i--) {
            const button = this._dropdownButtons[i];
            if (buttonIds.includes(button.id)) {
              button.handler = false;
            }
          }
        }
      }
    });
  }
};

function bindItemsArr() {
  if (!this._dropdownButtons) {
    this._dropdownButtons = [];
  }
}

function handleClick(button) {
  if (button.active) {
    button.active = false;
    return;
  }

  button.active = true;

  const domMenu = createMenu.call(this, button);

  domMenu.addEventListener("focusout", function(e) {
    if (e.relatedTarget && e.relatedTarget.id == button.id) {
      return;
    }

    button.active = false;
  });

  button.items.forEach(item => {
    const el = document.getElementById(item.id);
    el.addEventListener("click", item.callback);
  });

  setMenuPosition.call(this, button);
  removeMenuAtDeactivation.call(this, button);
  domMenu.focus();
}

function createMenu(button) {
  const template = `
    <ul ${
      button.menuWidth ? `style="width: ${button.menuWidth}px;"` : ""
    } class="c-dropdown bg-extra-light-gray" tabindex="-1" id="m_${button.id}">
      ${button.items
        .map(
          item =>
            `<li class="hover-primary hover-text-white" id="${item.id}">${item.content}</li>`
        )
        .join("")}
    </ul>
  `;

  const menu = htmlToElement(template);
  this.$el.appendChild(menu);

  return menu;
}

function setMenuPosition(button) {
  const domButton = document.getElementById(button.id);
  const buttonCoords = domButton.getBoundingClientRect();
  const domMenu = document.getElementById(`m_${button.id}`);
  const menuCoords = domMenu.getBoundingClientRect();
  const isOutsideWindows =
    buttonCoords.bottom + menuCoords.height + 10 > window.innerHeight;
  if (isOutsideWindows) {
    domMenu.style.bottom = window.innerHeight - buttonCoords.top + "px";
  } else {
    domMenu.style.top = buttonCoords.bottom + "px";
  }
  domMenu.style.right = window.innerWidth - buttonCoords.right + "px";
}

function removeMenuAtDeactivation(button) {
  const domButton = document.getElementById(button.id);
  const initialCoords = domButton.getBoundingClientRect();

  function checkRecursive(coords) {
    if (initialCoords.x != coords.x || initialCoords.y != coords.y) {
      button.active = false;
    }

    if (!button.active) {
      const domMenu = document.getElementById(`m_${button.id}`);
      if (domMenu) {
        domMenu.remove();
      }
    }

    if (button.active) {
      requestAnimationFrame(() => {
        const coords = domButton.getBoundingClientRect();
        checkRecursive(coords);
      });
    }
  }

  checkRecursive(initialCoords);
}

function htmlToElement(html) {
  var template = document.createElement("template");
  html = html.trim();
  template.innerHTML = html;
  return template.content.firstChild;
}
